export const createAiAssistantStartThreadRequest = (message) => {
  return {
    url: "/chat_threads",
    method: "POST",
    data: {
      message,
    },
  };
};

export const createAiAssistantGetActiveThreadIdRequest = () => {
  return {
    url: "/chat_threads/latest_thread_id",
    method: "GET",
  }
}


export const createAiAssistantGetThreadRequest = (threadId) => {
  return {
    url: "/chat_threads/" + threadId,
    method: "GET",
  };
};

export const createAiAssistantGetListThreadsRequest = () => {
  return {
    url: "/chat_threads/",
    method: "GET",
  };
};

export const createAiAssistantArchiveThreadRequest = (threadId) => {
  return {
    url: "/chat_threads/" + threadId + "/archive",
    method: "POST",
  };
};

export const createAiAssistantContinueThread = (
  external_thread_id,
  message
) => {
  return {
    url: "/chat_threads/continue_thread",
    method: "POST",
    data: {
      message,
      external_thread_id,
    },
  };
};

export const createAiAssistantGetThreadsByExternalThreadId = (
  externalThreadId
) => {
  return {
    url: "/chat_threads/by_external_thread_id/" + externalThreadId,
    method: "GET",
  };
};

export const createCustomPromptRequest = (title, prompt) => {
  return {
    url: "/custom_prompts",
    method: "POST",
    data: {
      title,
      prompt,
    },
  };
};

export const createGetAllCustomPromptsRequest = () => {
  return {
    url: "/custom_prompts",
    method: "GET",
  };
};

export const createUpdateCustomPromptRequest = (id, title, prompt) => {
  return {
    url: "/custom_prompts/" + id,
    method: "PUT",
    data: {
      title,
      prompt,
    },
  };
};

export const createGetCustomPromptRequest = (id) => {
  return {
    url: "/custom_prompts/" + id,
    method: "GET",
  };
};
